

const Blog=()=>{
    return (<>
        <h2>Blog</h2>
    </>)
}

export default Blog;